import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { BoardThemeProvider } from '@/components/chess/board-theme'
import SiteHeader from '@/components/landing/site-header'
import HeroSection from '@/components/landing/hero-section'
import MarqueeStrip from '@/components/landing/marquee-strip'
import FeaturesSection from '@/components/landing/features-section'
import ModesSection from '@/components/landing/modes-section'
import PuzzleSection from '@/components/landing/puzzle-section'
import ThemesSection from '@/components/landing/themes-section'
import ArenasSection from '@/components/landing/arenas-section'
import PlayersSection from '@/components/landing/players-section'
import PricingSection from '@/components/landing/pricing-section'
import FaqSection from '@/components/landing/faq-section'
import PlaySection from '@/components/landing/play-section'
import SiteFooter from '@/components/landing/site-footer'

const Home: FC = (): ReactNode => {
    return (
        <BoardThemeProvider>
            <Seo />
            <SiteHeader />

            <Layout>
                <HeroSection />
                <MarqueeStrip />
                <FeaturesSection />
                <ModesSection />
                <PuzzleSection />
                <ThemesSection />
                <ArenasSection />
                <PlayersSection />
                <PricingSection />
                <FaqSection />
                <PlaySection />
            </Layout>

            <SiteFooter />
        </BoardThemeProvider>
    )
}

export default Home
